(function () {
  if (!window.Flickity || !window.Flickity.prototype) return;

  // selector cần loại trừ
  var EXCLUDE_SELECTOR = '.product-slideshow';

  // Thêm _watchCSS nếu vendor chưa có
  if (typeof Flickity.prototype._watchCSS !== 'function') {
    Flickity.prototype._watchCSS = function () {
      // ❗ chỉ xử lý khi bật watchCSS, và KHÔNG áp dụng cho .product-slideshow
      if (!this.options || !this.options.watchCSS) return;
      if (this.element && this.element.matches && this.element.matches(EXCLUDE_SELECTOR)) return;

      var content = '';
      try {
        content = getComputedStyle(this.element, ':after').content || '';
      } catch (e) {}

      var shouldBeActive = content.indexOf('flickity') !== -1;

      if (shouldBeActive && !this.isActive) {
        this.activate && this.activate();
      } else if (!shouldBeActive && this.isActive) {
        this.deactivate && this.deactivate();
      }
    };
  }

  // Lặp qua các instance watchCSS, TRỪ .product-slideshow
  function forEachWatchCSSInstance(fn) {
    var nodes = document.querySelectorAll('[data-flickity], .flickity-enabled');
    nodes.forEach(function (el) {
      // bỏ qua nếu là .product-slideshow (trực tiếp hoặc wrapper mục tiêu)
      if (el.matches && el.matches(EXCLUDE_SELECTOR)) return;

      var inst = window.Flickity && window.Flickity.data && window.Flickity.data(el);
      if (!inst) return;

      // nếu element thật sự của instance có class exclude → bỏ qua
      if (inst.element && inst.element.matches && inst.element.matches(EXCLUDE_SELECTOR)) return;

      if (inst.options && inst.options.watchCSS && typeof inst._watchCSS === 'function') {
        fn(inst);
      }
    });
  }

  function recheckWatchCSS() {
    forEachWatchCSSInstance(function (inst) { inst._watchCSS(); });
  }

  // Thời điểm re-check
  window.addEventListener('load', recheckWatchCSS);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(recheckWatchCSS, 0); });

  // breakpoint thay đổi
  try {
    var mq = window.matchMedia('(max-width: 749px)');
    if (mq && mq.addEventListener) mq.addEventListener('change', recheckWatchCSS);
    else if (mq && mq.addListener) mq.addListener(recheckWatchCSS);
  } catch (e) {}

  // resize debounce bằng rAF
  var rafId;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(recheckWatchCSS);
  });

  // DOM thêm/bớt section/slider động
  try {
    var mo = new MutationObserver(function (muts) {
      var touched = muts.some(function (m) {
        return Array.from(m.addedNodes || []).some(function (n) {
          if (n.nodeType !== 1) return false;
          if (n.matches && n.matches(EXCLUDE_SELECTOR)) return false; // node bị exclude
          return n.matches && (n.matches('[data-flickity], .flickity-enabled')) ||
                 (n.querySelector && n.querySelector('[data-flickity], .flickity-enabled'));
        });
      });
      if (touched) requestAnimationFrame(recheckWatchCSS);
    });
    var observeTarget = document.getElementById('MainContent') || document.documentElement;
    mo.observe(observeTarget, { childList: true, subtree: true });
  } catch (e) {}
})();